// Short run-event messages (start, checkpoint, interruptions, save/load),
// stacked under the timer.

import { el } from './dom';

export type ToastKind = 'good' | 'bad' | 'info';

const MAX = 4;

export class Toasts {
  readonly root = el('div', 'hud-toasts');

  show(text: string, kind?: ToastKind, duration = 3000): void {
    const t = el('div', `hud-toast${kind ? ` ${kind}` : ''}`);
    if (kind === 'good' || kind === 'bad') t.appendChild(el('span', 'hud-toast-icon', kind === 'good' ? '✓' : '!'));
    t.appendChild(document.createTextNode(text));
    this.root.appendChild(t);
    while (this.root.children.length > MAX) this.root.firstChild?.remove();
    setTimeout(() => t.classList.add('fade'), duration);
    setTimeout(() => t.remove(), duration + 400);
  }

  clear(): void {
    this.root.replaceChildren();
  }
}
